var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GlobalTitlte"},[_c('h2',[_vm._v(_vm._s(_vm.En))]),_vm._v(" "),_c('div',{class:[_vm.flex ? 'flex-s' : '']},[_c('WordWithUnderlineVue',{attrs:{"words":_vm.Zh}}),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd119fc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalTitlte.vue
// module id = yvzU
// module chunks = 1